module.exports = __webpack_public_path__ + "static/media/Mapa-Brasil.29cd30ff.svg";